
import PDF from './electronicSeal'
import Vue from 'vue'
import store from '../../../../../../store'
var $pdfFile
export default {
  install (fileId,options,suffix) {

    if (!$pdfFile) {
      const PDFPlugin = Vue.extend(PDF)
      $pdfFile = new PDFPlugin().$mount()
      document.body.appendChild($pdfFile.$el)
      $pdfFile.init(fileId,options,suffix)
    }else{
      $pdfFile.init(fileId,options,suffix)
      
    }
    // Vue.prototype.$showPDF = function (that,url,operate) {
    //   $vm.showPDF(that,url,operate)
    // }
  }
}
Vue.prototype.$store = store


// WEBPACK FOOTER //
// ./src/components/paging/pcClient/popupModule/structFile/seal/index.js